import calculationReviewIcon from '../../../images/Calculation Review.svg';

// todo: might allow more styling here, like fluent icons would, but that's a later problem
// their package is fancy and generates stuff from svgs using python so.
export const CalculationReviewRegular = ({ width, height }: { width: string | number; height: string | number }) => {
    return <img src={calculationReviewIcon} alt="" aria-hidden={true} width={width} height={height} />;
};
